import React, { useContext, useState } from "react";
import { Button } from "../../../controls";
import { LogoutRounded, ManageAccountsRounded } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { action, API, controller } from "../../../api/api";
import { AppContext } from "../../../App";
import { Dialog, Snackbar } from "../../../layout";
import SwitchUser from "./Switch/SwitchUser";

const UserAction = () => {
  const { setAuthUser } = useContext(AppContext);
  const [showSwitchForm, setShowSwitchForm] = useState(false);
  const navigate = useNavigate();
  const [snackbar, setSnackbar] = useState({
    show: false,
    type: "error",
    msg: "",
  });

  const handleLogout = () => {
    API(controller.Auth + action.Logout).get(() => {
      setAuthUser();
      navigate("/auth");
    });
    navigate("/auth");
  };

  const handleSwitch = () => {
    setShowSwitchForm(!showSwitchForm);
  };

  return (
    <>
      <div className="grid p-[20px] gap-4">
        <Button
          onClick={handleSwitch}
          size="medium"
          className="!text-[18px]"
          startIcon={<ManageAccountsRounded />}
        >
          Switch user
        </Button>
        <Button
          onClick={handleLogout}
          size="medium"
          className="!text-[18px] !text-red-500 !bg-red-100"
          startIcon={<LogoutRounded />}
        >
          Logout
        </Button>
      </div>
      {/* Switch User Form */}
      {showSwitchForm && (
        <Dialog show={showSwitchForm} onClose={false} maxWidth="md">
          <SwitchUser
            {...{
              setShowForm: setShowSwitchForm,
              showForm: showSwitchForm,
              setSnackbar,
            }}
          />
        </Dialog>
      )}
      {snackbar && (
        <Snackbar
          autoHideDuration={2000}
          snackbar={snackbar}
          setSnackbar={setSnackbar}
          vertical="bottom"
          horizontal="left"
        />
      )}
    </>
  );
};

export default UserAction;
